
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import {
    apiShopMoneyLogGetTypeList, apiShopStatistics, apiShopLists
} from "@/api/shop";
import SearchBtns from "@/components/search-btns.vue";
import { RequestPaging } from "@/utils/util";
import DatePicker from "@/components/date-picker.vue";
import LsPagination from "@/components/ls-pagination.vue";
import elImageViewer from "element-ui/packages/image/src/image-viewer.vue";
import ExportData from '@/components/export-data/index.vue'

@Component({
    components: {
        LsPagination,
        DatePicker,
        elImageViewer,
        SearchBtns,
        ExportData
    },
})
export default class OrderList extends Vue {
    // 界面表格数据
    pager: any = new RequestPaging();

    apiShopStatistics = apiShopStatistics;
    searchObj: any = {
        sid: '',
        type: "",
        target_type: "",
        start_time: "",
        end_time: "",
    };
    money_type_list: any[] = [];
    type_list: any[] = [];
    time: any = [];
    loading = false;
    shopList: any[] = [];



    // 日期选择器配置
    pickerOptions = {
        shortcuts: [
            {
                text: "最近一周",
                onClick(picker: any) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                    picker.$emit("pick", [start, end]);
                },
            },
            {
                text: "最近一个月",
                onClick(picker: any) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                    picker.$emit("pick", [start, end]);
                },
            },
            {
                text: "最近三个月",
                onClick(picker: any) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                    picker.$emit("pick", [start, end]);
                },
            },
        ],
    };
    handleSearch() {
        this.pager.page = 1;
        this.getList();
    }
    changeDate() {
        if (this.time.length) {
            this.searchObj.start_time = this.time[0];
            this.searchObj.end_time = this.time[1];
        }
    }
    getList() {
        this.loading = true; // 开始加载状态
        this.pager
            .request({
                callback: this.apiShopStatistics,
                params: this.searchObj, // 传递搜索参数
            })
            .then((res: any) => {
                this.loading = false; // 请求完成，停止加载状态
            })
            .catch((error: any) => {
                console.error("获取订单列表失败:", error);
            });
    }
    // 获取钱包类型列表
    async getSourceList() {
        try {
            let result = await apiShopMoneyLogGetTypeList({})
            let money_type_list = result.money_type
            money_type_list.unshift({
                id: '',
                name: '全部'
            })
            let type_list = result.type
            type_list.unshift({
                id: '',
                name: '全部'
            })
            console.log(money_type_list)
            this.money_type_list = money_type_list
            this.type_list = type_list
        } catch (error) {

        }
    }

    async getShopList() {
        try {
            let res = await apiShopLists({ page_size: 9999 })
            this.shopList = res.lists;
        } catch (error) {

        }
    }
    async mounted() {
        await this.getSourceList();
        await this.getShopList()
        this.getList();
    }

}
